/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notifications_UnreadInputs */

const cs_notifications_unread = /** @type {(inputs: Notifications_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} nepřečtených`)
};

const en_notifications_unread = /** @type {(inputs: Notifications_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unread`)
};

/**
* | output |
* | --- |
* | "{count} unread" |
*
* @param {Notifications_UnreadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_unread = /** @type {((inputs: Notifications_UnreadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_UnreadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_unread(inputs)
	return cs_notifications_unread(inputs)
});